import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import gsap from 'gsap';

function basicSlider(){
	const sliderElement = document.querySelector('.testimonial-slider');
	if (sliderElement && sliderElement.querySelectorAll('.swiper-slide').length > 1) {
		const slider = new Swiper('.testimonial-slider', {
			modules: [Navigation, Pagination, Autoplay],
			loop: true,
			draggable: true,
			allowTouchMove: true,
			effect: 'fade',
			slidesPerView: 1,
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
				clickable: true,
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			breakpoints: {
				760: {
					slidesPerView: 1,
				},
				992: {
					slidesPerView: 1,
				},
			},
		});
	}

	



	function arcSlider(){
		const multiplier = {
			translate: .1,
			rotate: .01
		}
		
		const arcslider = new Swiper('.arc-slider', { 
			slidesPerView: 4,
			modules: [Navigation, Pagination, Autoplay],
			spaceBetween: 90,
			centeredSlides: true,
			loop: true,
			grabCursor: true,
			observer: true, 
			observeParents: true,
			watchSlidesVisibility: true,
            watchSlidesProgress: true,
			duration: 1200,
			speed: 1200,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.arc-slider .swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: '.arc-slider .swiper-button-next',
				prevEl: '.arc-slider .swiper-button-prev',
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 90,
					
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 90,
					
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 90,
					
				},
				1280: {
					slidesPerView: 4,
					spaceBetween: 90,
					
				}
			},
			on: {
				init: function() {
					if (window.innerWidth >= 768) {
						const activeSlide = this.slides[this.activeIndex];
						const quote = activeSlide.querySelector('.quoteperson');
						if (quote) {
							gsap.fromTo(quote,
								{autoAlpha: 0},
								{autoAlpha: 1, duration: .7, ease: 'power3.in'}
							);
						}
					}
				},
				slideChangeTransitionStart: function () {
					if (window.innerWidth >= 768) {
						// Hide all quotes first
						const allQuotes = document.querySelectorAll('.quoteperson');
						allQuotes.forEach(quote => {
							gsap.set(quote, {autoAlpha: 0});
						});

						// Animate the active slide's quote
						const activeSlide = this.slides[this.activeIndex];
						const activeQuote = activeSlide.querySelector('.quoteperson');
						if (activeQuote) {
							gsap.fromTo(activeQuote,
								{autoAlpha: 0},
								{autoAlpha: 1, duration: .7, ease: 'power3.in'}
							);
						}
					}
				}
			},
		
		})
		

		
		function calculateWheel() {
			const slides = document.querySelectorAll('.single')
			slides.forEach((slide, i) => {
				const rect = slide.getBoundingClientRect()
				const r = window.innerWidth * .5 - (rect.x + rect.width * .5)
				let ty = Math.abs(r) * multiplier.translate - rect.width * multiplier.translate
		
				if (ty < 0) {
					ty = 0
				}
				const transformOrigin = r < 0 ? 'left top' : 'right top'
				slide.style.transform = `translate(0, ${ty}px) rotate(${-r * multiplier.rotate}deg)`
				slide.style.transformOrigin = transformOrigin
			})
		}
		
		function raf() {
			requestAnimationFrame(raf)
			calculateWheel()
		}
		
		raf();

	
	}
	arcSlider();

}

export { basicSlider };